var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1692 8.74219C24.1692 8.74219 18.7966 16.7422 12.1692 16.7422C5.54177 16.7422 0.169189 8.74219 0.169189 8.74219C0.169189 8.74219 5.54177 0.742188 12.1692 0.742188C18.7966 0.742188 24.1692 8.74219 24.1692 8.74219ZM6.452 8.74219C6.452 10.6436 7.74748 14.0797 12.1692 14.0797C16.5909 14.0797 17.8512 10.6721 17.8512 8.74219C17.8512 6.81229 16.5909 3.40472 12.1692 3.40472C7.74748 3.40472 6.452 6.84079 6.452 8.74219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0be58803e24239eb8ff71b5c9a653038.svg";
export { ForwardRef as ReactComponent };